import { exhaustiveArray } from "@aprao/common/src/array/exhaustiveArray.js";
import { checkedMapFromEntries } from "@aprao/common/src/map/checkedMapFromEntries.js";
import type { SiteUseClass } from "@aprao/model/src/shapes/ShapeSitePurchase.js";

export const useClassLabels = exhaustiveArray<
  {
    [type in SiteUseClass]: [type, string];
  }[SiteUseClass]
>().ensure([
  ["Residential.2025-04-01", "residential" as string],
  ["Residential.2022-09-23", "residential (before 01/04/2025)" as string],
  ["Residential", "residential (before 23/09/2022)" as string],
  ["NonResidential", "non-residential and mixed use" as string],
]);

export const labelByUseClass = checkedMapFromEntries(useClassLabels);
